import React, { Component, useReducer } from 'react';
import {Table, Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Triangle} from 'react-loader-spinner'

  class Wallet extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        payments: [],
        loading: true,
        amount: 0,
        paypal_email: ''
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.RequestWithdrawal = (balance) => {
        if (
            this.state.amount == 0 ||
            this.state.paypal_email == ''
        ){
            alert('You need to fill in all the fields.')
        }else{
            if (this.state.amount > balance){
                alert('Withdrawal amount cannot be greater than your available balance.')
            }else{
                this.setState({loading: true})
                const { cookies } = this.props;
                var data = new FormData()
                data.append('user_access_token', cookies.get('token'))
                data.append('amount', this.state.amount)
                data.append('paypal_email', this.state.paypal_email)
          
                axios.post(Backend_Url + 'makeWithdrawalRequest', data)
                .then((res) => {
                    let result = res.data
                      this.setState({loading: false})
                }).catch((error) => {
                    console.log(error)
                    this.RequestWithdrawal()
                })
            }
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
      
        const { cookies } = this.props;
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
  
        axios.post(Backend_Url + 'getWalletData', data)
        .then((res) => {
            let result = res.data
              this.setState({payments: result, loading: false})
        }).catch((error) => {
            console.log(error)
        })
    }


    render() {
      if (this.state.loading == true){
        return<Row>
          <div style={{backgroundColor: '#ffffff', minHeight: '550px', opacity: 0.9, minHeight: '1000px'}}>
            <Container style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
              <br/>
              <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                ONFIT
              </h1>
              <br/><br/>
              <Triangle
                  color="#1FACED"
                  height={130}
                  width={130}
              />
              <h3 style={{marginTop: '50px', color: '#1FACED'}}>
                Loading...
              </h3>
              <h6 style={{marginTop: '50px'}}>
                  Taking too long to load? Check your internet connection and reload the page.
              </h6>
              <br/><br/>
            </Container>
          </div>
        </Row>
      }

      var total_received = this.state.payments.reduce((acc, payment) => acc + payment.amount, 0);
      var withdrawals = this.state.payments.filter(payment => payment.reason == 'Withdrawal')
      var total_withdrawn = withdrawals.reduce((acc, withdrawal) => acc + withdrawal.amount, 0);
      var remaining = total_received - total_withdrawn

      var payments_map = this.state.payments.map((payment, index) => {
        return<tr style={{borderBottom: '1px solid #1faced'}}>
            <td>€{payment.amount}</td>
            <td>{payment.reason}</td>
            <td>{payment.date_of_payment}</td>
        </tr>
    })

      return (
        <Row>
            <Helmet>
              <title>Trainer Wallet - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h4 style={{}}>
                Wallet
              </h4>
              <br/><br/><br/><br/>
              <Container>
                  <Row>
                      <Col sm='8'>
                        <Row>
                            <Col sm='3'>
                                <div style={{backgroundColor: '#1FACED', height: '150px', width: '150px', borderRadius: '50%'}}>
                                    <Container style={{paddingTop: '15px'}}>
                                        <div style={{backgroundColor: '#FFFFFF', height: '120px', width: '120px', borderRadius: '50%'}}>
                                        <h3 style={{'paddingTop': '30px'}}>
                                            €{total_received}
                                        </h3>
                                        <p>
                                            Earned
                                        </p>
                                        </div>
                                    </Container>
                                </div>
                            </Col>
                            <Col sm='3'>
                                <div style={{backgroundColor: '#1FACED', height: '150px', width: '150px', borderRadius: '50%'}}>
                                    <Container style={{paddingTop: '15px'}}>
                                        <div style={{backgroundColor: '#FFFFFF', height: '120px', width: '120px', borderRadius: '50%'}}>
                                        <h3 style={{'paddingTop': '30px'}}>
                                            €{total_withdrawn}
                                        </h3>
                                        <p>
                                            Withdrawn
                                        </p>
                                        </div>
                                    </Container>
                                </div>
                            </Col>
                            <Col sm='3'>
                                <div style={{backgroundColor: '#1FACED', height: '150px', width: '150px', borderRadius: '50%'}}>
                                    <Container style={{paddingTop: '15px'}}>
                                        <div style={{backgroundColor: '#FFFFFF', height: '120px', width: '120px', borderRadius: '50%'}}>
                                        <h3 style={{'paddingTop': '30px'}}>
                                            €{remaining}
                                        </h3>
                                        <p>
                                            Balance
                                        </p>
                                        </div>
                                    </Container>
                                </div>
                            </Col>
                        </Row>
                        <br/><br/>
                      </Col>
                      <Col>
                        <h5>
                            Request Withdrawal
                        </h5>
                        <br/>
                        <input name='amount' value={this.state.amount} onChange={this.HandleChange} type='number' placeholder='Amount to withdraw'
                            style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                        <br/><br/>
                        <input name='paypal_email' value={this.state.paypal_email} onChange={this.HandleChange} type='text' placeholder='Paypal email'
                            style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                        <br/><br/><br/>
                        <Button onClick={() => this.RequestWithdrawal(remaining)} style={{border: 'none', backgroundColor: '#1faced', color: '#ffffff', minWidth: '40%', borderRadius: '20px'}}>
                            Submit Request
                        </Button>
                      </Col>
                  </Row>
                  <br/><br/>
                  <h5>
                      Payment Activity
                  </h5>
                  <br/>
                <Table>
                    <thead>
                        <tr>
                            <th width='30%'>Amount</th>
                            <th width='30%'>Category</th>
                            <th width='30%'>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments_map}
                    </tbody>
                </Table>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Wallet);